import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";

export const LoadingRow = styled(Stack)({
    flexDirection: "row",
    justifyContent: "space-between",
});

export const LoadingSidebar = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "50%",
    }),
);

export const LoadingDetail = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: "48.3%",
    }),
);

export const DesktopRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        justifyContent: "space-between",
    }),
);

export const Sidebar = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexShrink: 0,
        width: "50%",
        pt: 2,
    }),
);

export const DetailBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        width: "48.3%",
    }),
);

export const MobileScrollContainer = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        alignItems: "stretch",
        overflowX: "auto",
        px: 4,
        pb: 2,
        scrollSnapType: "x mandatory",
        "&::-webkit-scrollbar": { display: "none" },
    }),
);

export const MobileCardBox = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isSelected" && prop !== "isDisabled",
})<{ isSelected?: boolean; isDisabled?: boolean }>(({ theme, isSelected, isDisabled }) => {
    const selectedState = isSelected ? 1 : 0.7;
    const resolvedOpacity = isDisabled ? 0.5 : selectedState;
    return theme.unstable_sx({
        scrollSnapAlign: "start",
        cursor: isDisabled ? "default" : "pointer",
        opacity: resolvedOpacity,
        transition: "opacity 0.2s",
        ...(isDisabled && {
            pointerEvents: "none",
        }),
    });
});

export const MobileLoadingRow = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        flexDirection: "row",
        px: 4,
    }),
);

export const DesktopPageRoot = styled(Stack)({});

export const MobilePageRoot = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        justifyContent: "space-between",
    }),
);

export const MobileSkeletonCard = styled(Skeleton)(({ theme }) =>
    theme.unstable_sx({
        minWidth: "70vw",
        height: 115,
        borderRadius: 1,
        flexShrink: 0,
    }),
);
